/**
 * setPlayedAnswer.js
 * Written by: Alex Kasemir
 */

export const SET_PLAYED_ANSWER = `SET_PLAYED_ANSWER`;

/**
 * Description of the setPlayedAnswer action
 */
export const setPlayedAnswer = (id, playedAnswer) => ({
  type: SET_PLAYED_ANSWER,
  id,
  playedAnswer,
});

export default setPlayedAnswer;
